import React, { Component } from 'react'
import store from './store'
import { Input, AutoComplete } from 'hljd'
import { observer } from 'mobx-react'

@observer
class CheckInput extends Component {
  static defaultProps = {
    getFieldError: () => {}
  }
  componentDidMount() {
    this.id = store.pushList({
      type: this.props.type || 2,
      value: this.props.value || ''
    })
  }
  componentWillUnmount() {
    store.removeList(this.id)
  }
  onBlur = async () => {
    if (this.props.getFieldError(this.props.id)) {
      store.resetItem(this.id)
    } else {
      const data =
        (await store.checkWord(
          this.props.value || '1',
          this.props.type || 2
        )) || {}
      const { code, keywords } = data
      const words = `存在敏感词 ${keywords.join(',')}`
      store.replaceItem(this.id, code == 1 ? words : '')
      this.forceUpdate()
    }
  }

  onChange = e => {
    const { onChange } = this.props
    const value = e.target ? e.target.value : e
    onChange && onChange(value)
    store.changeValue(this.id, value)
  }
  render() {
    const itemData = this.id
      ? store.checkList.find(item => item.id == this.id) || {}
      : {}
    const {
      onChange,
      type,
      autoComplete,
      children,
      errRef,
      getFieldError,
      ...rest
    } = this.props

    const props = {
      ...rest,
      onBlur: this.onBlur,
      onChange: this.onChange
    }
    return (
      <>
        {children &&
          React.cloneElement(children, {
            ...rest,
            onBlur: this.onBlur,
            onChange: this.onChange
          })}
        {!children &&
          autoComplete && (
            <AutoComplete {...props} placeholder="">
              <Input {...props} />
            </AutoComplete>
          )}
        {!children && !autoComplete && <Input {...props} />}
        {!!itemData.msg && (
          <p
            ref={errRef}
            id="checkInput-err-msg"
            style={{ color: '#ff5c5c', lineHeight: 1 }}
          >
            {itemData.msg}
          </p>
        )}
      </>
    )
  }
}

export default CheckInput
